import styled from 'styled-components';

const fontBase = 14;

export const AppWrapper = styled.div`
  height: auto;
  top: 0;
  left: 0;
  width: 100%;
  *:not(h1, h2, h3, h4, h5) {
    font-size: ${fontBase}px;
  }
`;
